import { Button, Card, CardContent, CardHeader, CardTitle, Skeleton } from '@planuze/ui';
import type { ReactNode } from 'react';
import { useMetricsWidgetsContent } from '../../content/sections/metrics-widgets.js';

interface Props {
  readonly title: string;
  readonly loading: boolean;
  readonly empty: boolean;
  readonly children: ReactNode;
  /** Diferencia "sem dados" de "sem resultados p/ o filtro" (empty-state escopado). */
  readonly hasFilters?: boolean | undefined;
  /** Limpa TODOS os filtros do call site; habilita o CTA no empty filtrado. */
  readonly onClearFilters?: (() => void) | undefined;
}

/* Shell de card de gráfico com os estados explícitos da jornada (§6): loading (skeleton) /
   empty (sem dados vs. sem resultados quando há filtro) / data. Erro é tratado na página. */
export function ChartCard({ title, loading, empty, children, hasFilters, onClearFilters }: Props) {
  const copy = useMetricsWidgetsContent().chartCard;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Skeleton className="h-[300px] w-full" />
        ) : empty ? (
          hasFilters === true && onClearFilters !== undefined ? (
            <div className="grid h-[300px] place-items-center gap-3 text-center">
              <p className="text-sm text-muted-foreground">{copy.emptyFilteredMessage}</p>
              <Button variant="outline" size="sm" onClick={onClearFilters}>
                {copy.clearFilters}
              </Button>
            </div>
          ) : (
            <div className="grid h-[300px] place-items-center text-sm text-muted-foreground">
              {copy.emptyMessage}
            </div>
          )
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
